import React from "react"
import { Button } from "./../atoms"

const RequestAssistanceCTA = (props) => {
  return (
    <div className="relative lg:h-32">
      <div className="bg-black black-cta-bar -mx-4 lg:mx-0 px-4 lg:px-0 py-8 lg:py-0">
        <div className="container mx-auto h-full lg:px-4">
          <div className="lg:px-5 h-full flex flex-col lg:flex-row items-center justify-between">
            <span className="text-white text-2xl mr-8 mb-8 lg:mb-0">
              Having trouble creating your ad? Let us help you!
            </span>
            <Button
              variant="hollow-invert"
              onClick={() => props.history.push("/requestassistance")}
            >
              Request studio assistance
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RequestAssistanceCTA
